import { EmailsThemeDto } from "@babackapp/private-api-client/types";
import React from "react";
import { ButtonVariant } from "./types";
import { getContrastText } from "@babackapp/ui/lib/colors";

export type { ButtonVariant };

export interface ThemeButtonProps {
  variant: ButtonVariant;
  buttonRadius?: string;
  theme: EmailsThemeDto;
  textColor: string;
}

export function getThemeButtonStyle({
  theme,
  variant,
  textColor,
}: ThemeButtonProps): React.CSSProperties {
  const baseStyles: React.CSSProperties = {
    fontWeight: 500,
    padding: "8px 16px",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  };

  switch (variant) {
    case "primary":
      return {
        ...baseStyles,
        backgroundColor: theme.primaryColor || "#000000",
        color: theme.primaryTextColor || "#FFFFFF",
      };
    case "secondary":
      return {
        ...baseStyles,
        backgroundColor: theme.secondaryColor || "#000000",
        color: theme.secondaryTextColor || "#FFFFFF",
      };
    case "outline":
      return {
        ...baseStyles,
        backgroundColor: "transparent",
        color: textColor || theme.primaryTextColor || "#000000",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: textColor || theme.primaryTextColor || "#000000",
      };
    default:
      return {
        ...baseStyles,
        backgroundColor: textColor || theme.primaryTextColor || "#000000",
        color: getContrastText(
          textColor || theme.primaryTextColor || "#000000",
        ),
      };
  }
}
